module.exports = __webpack_public_path__ + "img/fd_icon.ef3f2e28.svg";